import { render, staticRenderFns } from "./uploadAnnex.vue?vue&type=template&id=23851f37&scoped=true"
import script from "./uploadAnnex.vue?vue&type=script&lang=js"
export * from "./uploadAnnex.vue?vue&type=script&lang=js"
import style0 from "./uploadAnnex.vue?vue&type=style&index=0&id=23851f37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23851f37",
  null
  
)

export default component.exports